import axiosInstance from "config/axios-config";
import { profile } from "context/profile";

/**
 * ===============================
 * Update User Profile
 * ===============================
 */

/**
 * Updates user profile information.
 *
 * - Sends updated fields to backend
 * - Updates local profile context if successful
 *
 * @param {Object} payload - Data to update (firstName, lastName, email, etc.)
 * @returns {Promise<Object|null>} Updated user data or null if failed
 */
export const updateUserProfile = async (payload) => {
  try {
    const endpoint = "/users/update-profile";
    const res = await axiosInstance.put(endpoint, payload);

    if (!res.data.success) {
      return null;
    }

    const data = res.data.data;

    // Update profile only if fields exist
    if (data.firstName) profile.first_name = data.firstName;
    if (data.lastName) profile.last_name = data.lastName;
    if (data.email) profile.email = data.email;
    if (data.mobile) profile.phone_number = data.mobile;
    if (data.role) profile.role = data.role;

    return data;
  } catch (err) {
    throw err;
  }
};
